<ion-header>
  <ion-toolbar class="header-color ion-text-center">
    <ion-title>My Reservations</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <app-promoga-alert></app-promoga-alert>
</ion-header>
<ion-content>
  <!-- Checkboxes in a List -->

  <ion-grid class="ion-no-padding ion-no-margin ui-reserv-select-wr">
    <ion-row>
      <ion-col size="4" class="ion-no-padding ion-no-margin" *ngFor="let time of filterData.times">
        <ion-item class="ion-no-padding ion-no-margin">
          <ion-label>{{time.name}}</ion-label>
          <ion-checkbox color="secondary" [(ngModel)]="time.isChecked" (ionChange)="onTimeSlotChange()" class="ion-no-margin ion-margin-end ion-margin-start" slot="start" value="Morning"></ion-checkbox>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="padding-20" *ngIf="!purchases || purchases.length <= 0">
       <p class="text-center title-no-reservation">You have no reservations.</p>
       <p class="text-center info-no-reservation">Don't worry, you can book for one <a
        routerLink="/search/promotions">here</a>.</p>
  </div>
  <ng-container *ngFor="let purchase of purchases">
  <!--    Section of reservation  -->
  <ion-grid class="ion-no-padding ion-no-margin ui-reserv-wr" *ngIf="checkPurchaseExpiration(purchase)">
    <ion-row class="ui-reserv-info" *ngIf="purchase.sessions.length > 0">
      <ion-col class="ion-padding-start">
        <div class="ui-left">
                  <!-- <span class="time">@{{session.startdate | date:'h:mm a'}} to {{session.enddate | date:'h:mm a'}} PM</span> -->
          <div class="ui-title">{{purchase.promotion.classes.title}}<span class="ui-name">{{purchase.promotion.classes.instructor.first_name + ' ' + purchase.promotion.classes.instructor.last_name}}</span>
<span>
  <ion-chip *ngIf="getOnlineClassState(purchase)=='expired'">
      <ion-label> online </ion-label>
      <!-- <ion-icon danger name="radio-button-on"></ion-icon> -->
  </ion-chip>
  <ion-chip *ngIf="getOnlineClassState(purchase)=='pending'">
      <ion-label > online </ion-label>
      <ion-icon  name="radio-button-on"></ion-icon>
  </ion-chip>
  <ion-chip *ngIf="getOnlineClassState(purchase)=='current'" color="secondary">
      <ion-label > online </ion-label>
      <ion-icon color="success" name="radio-button-on"></ion-icon>
  </ion-chip>
    <svg *ngIf="hasOnlineClass(purchase)"
         (click)="openTooltip($event)" xmlns="http://www.w3.org/2000/svg" style="width: 1rem;"
         ba
         class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                clip-rule="evenodd"/>
                        </svg>
</span>
<span *ngIf="purchase.total_reservations/purchase.promotion.session_custom_value>1" style="color:#046376;">&nbsp;X {{ purchase.total_reservations/purchase.promotion.session_custom_value }} Passes</span>
          </div>
          <div class="ui-address" *ngIf="!hasOnlineClass(purchase)"> {{
            purchase.promotion.classes.venue.street_address +
            (purchase.promotion.classes.venue.suite_apt ? ' #' + purchase.promotion.classes.venue.suite_apt : '') +
            ', ' + purchase.promotion.classes.venue.city + ' ' + (purchase.promotion.classes.venue.province_state ? purchase.promotion.classes.venue.province_state : purchase.promotion.classes.venue.country)
            }}</div>
            <div class="ui-address" *ngIf="hasOnlineClass(purchase)">
              Online session will enable only 10 min. before start
            </div>
          <div class="ui-valid" *ngIf="purchase.promotion.session_value !== 1">Valid remaining {{purchase.sessions.length}} of {{purchase.total_reservations}} session pass </div>
          <div class="ui-valid" *ngIf="purchase.promotion.session_value === 1">Valid for drop-in sessions</div>
        </div>
      </ion-col>
      <ion-col size="3" class="ion-padding-end">
        <div class="ui-right">
          <div class="ui-price">{{ purchase.promotion.total_amount | currency:'CAD':'symbol-narrow'}} CAD</div>
        </div>
      </ion-col>
    </ion-row>
    <!--    Section item  -->
    <ng-container *ngFor="let session of purchase.sessions">
    <ion-row class="ui-reserv-item" *ngIf="checkSessionExpiration(session)">
      <ion-col class="ion-padding-start">
        <div class="ui-left">
          <div class="ui-slot">
            <span class="ui-date">{{session.startdate | date:'dd MMM yyyy'}}</span>
            <span class="ui-time">{{session.startdate | date:'h:mm a'}} to {{session.enddate | date:'h:mm a'}} &nbsp;
              <span *ngIf="!hasOnlineClass(purchase)">{{ timezoneService.getTimezoneCode(purchase.promotion.classes.venue.time_zone) }}</span>
              <span *ngIf="hasOnlineClass(purchase)">{{ userTimezone }}</span>
            </span>            
          </div>
        </div>
      </ion-col>
      <ion-col size="3" class="ion-padding-end">
        <div class="ui-right">
          <!-- <ion-badge color="medium" class="reservedBtn" expand="block">Expired</ion-badge> -->
          <ion-badge color="medium" *ngIf="getSessionState(session)=='expired'" class="ion-padding-horizontal">Expired</ion-badge>
          <a *ngIf="(purchase.promotion.classes.online_locations && purchase.promotion.classes.online_locations.length > 0 && session.classes.medium && session.classes.medium.length != 2) || (session.classes.medium && session.classes.medium.length == 2 && session.purchase.medium && session.purchase.medium.name == 'ONLINE')" (click)="joinOnlineClass(purchase)">
            <ion-button size="small" *ngIf="getSessionState(session)=='current'"color="tertiary" class="btn">Join Online</ion-button>
          </a>
          <a *ngIf="(!purchase.promotion.classes.online_locations || purchase.promotion.classes.online_locations.length == 0) || (session.classes.medium && session.classes.medium.length == 2 && session.purchase.medium && session.purchase.medium.name == 'ONSITE')">
            <ion-badge color="success" *ngIf="getSessionState(session)=='current'" class="ion-padding-horizontal">Reserved</ion-badge>
          </a>
          <div *ngIf="getSessionState(session)=='pending'">
            <ion-badge color="success" *ngIf="session.reservations && !session.enableReserved" class="ion-padding-horizontal" (click)="cancelSession(session, purchase.sessions)">Reserved</ion-badge>
            <ion-button size="small" *ngIf="session.reservations && session.purchase.promotion.session_custom_value > session.purchase.total_reservations && !session.enableReserved" color="medium"
               (click)="cancelSession(session, purchase.sessions)" class="btn">Change</ion-button>
            <ion-button size="small" *ngIf="session.enableReserved" (click)="reserveSession(session, purchase.sessions)" color="tertiary" class="btn">reserve</ion-button>
            <ion-button size="small" color="tertiary" *ngIf="!session.reservations && !session.enableReserved" class="btn" disabled>reserve</ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ng-container>
  </ion-grid>
</ng-container>
</ion-content>
